import { Button } from "@/components/ui";
import { FormProvider } from "react-hook-form";
import useStep2 from "./useStep2";
import { FormInput, FormPhoneInput, FormSelect, Loader } from "@/components";
import {
  ACCOUNT_NUMBER,
  CURRENT_BALANCE,
  PAYMENT_METHOD,
  PAYMENT_TERMS,
  PREVIOUS_BALANCE,
  ROUTING_NUMBER,
  STATE_TAX_ID,
  TAX_CODE,
  TAX_ID,
  ZELLE_EMAIL,
  ZELLE_PHONE,
} from "./consts";
import { FC } from "react";
import { StepsProps } from "../../types";

const Step2: FC<StepsProps> = ({ onCancel }) => {
  const {
    form,
    onSubmit,
    requiredFields,
    isAddPending,
    isUpdatePending,
    isView,
    isVendorDtlLoading,
    paymentMethodList,
    isPaymentMethodLoading,
    keys,
    paymentTermList,
    isPaymentTermLoading,
  } = useStep2();
  const { errors } = form.formState;

  return (
    <>
      {isVendorDtlLoading || isPaymentMethodLoading || isPaymentTermLoading ? (
        <Loader />
      ) : (
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px]">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[30px]">
                <FormInput
                  name={CURRENT_BALANCE}
                  control={form.control}
                  label="Current Balance"
                  placeholder="Please enter"
                  error={errors[CURRENT_BALANCE]?.message}
                  isRequired={requiredFields.includes(CURRENT_BALANCE)}
                  disabled={isView}
                  variant="integer"
                />
                <FormInput
                  name={PREVIOUS_BALANCE}
                  control={form.control}
                  label="Previous Year End Bal"
                  placeholder="Please enter"
                  error={errors[PREVIOUS_BALANCE]?.message}
                  isRequired={requiredFields.includes(PREVIOUS_BALANCE)}
                  disabled={isView}
                  variant="integer"
                />
                <FormInput
                  name={ROUTING_NUMBER}
                  control={form.control}
                  label="Bank Routing Number"
                  placeholder="Please enter"
                  error={errors[ROUTING_NUMBER]?.message}
                  isRequired={requiredFields.includes(ROUTING_NUMBER)}
                  disabled={isView}
                  variant="integer"
                  maxLength={9}
                />
                <FormInput
                  name={ACCOUNT_NUMBER}
                  control={form.control}
                  label="Bank Account Number"
                  placeholder="Please enter"
                  error={errors[ACCOUNT_NUMBER]?.message}
                  isRequired={requiredFields.includes(ACCOUNT_NUMBER)}
                  disabled={isView}
                  variant="integer"
                  maxLength={17}
                />
                <FormPhoneInput
                  name={ZELLE_PHONE}
                  control={form.control}
                  label="Zelle Phone No."
                  placeholder="Please enter"
                  error={errors[ZELLE_PHONE]?.message}
                  isRequired={requiredFields.includes(ZELLE_PHONE)}
                  disabled={isView}
                />
                <FormInput
                  name={ZELLE_EMAIL}
                  control={form.control}
                  label="Zelle Email ID"
                  placeholder="Please enter"
                  error={errors[ZELLE_EMAIL]?.message}
                  isRequired={requiredFields.includes(ZELLE_EMAIL)}
                  disabled={isView}
                />
                <FormSelect
                  key={keys?.paymentTerm}
                  name={PAYMENT_TERMS}
                  control={form.control}
                  label="Payment Terms"
                  placeholder="Please enter"
                  error={errors[PAYMENT_TERMS]?.message}
                  isRequired={requiredFields.includes(PAYMENT_TERMS)}
                  disabled={isView}
                  options={(paymentTermList?.data || [])?.map((data: any) => ({
                    label: data?.paymentTermName,
                    value: data?.paymentTermId?.toString(),
                  }))}
                />
                <FormSelect
                  key={keys?.paymentMethod}
                  name={PAYMENT_METHOD}
                  control={form.control}
                  label="Payment Method"
                  placeholder="Please select"
                  error={errors[PAYMENT_METHOD]?.message}
                  isRequired={requiredFields.includes(PAYMENT_METHOD)}
                  disabled={isView}
                  options={(paymentMethodList?.data || [])?.map(
                    (data: any) => ({
                      label: data?.methodName,
                      value: data?.paymentMethodId?.toString(),
                    })
                  )}
                />
                <FormInput
                  name={TAX_CODE}
                  control={form.control}
                  label="Tax Jurisdiction Code"
                  placeholder="Please enter"
                  error={errors[TAX_CODE]?.message}
                  isRequired={requiredFields.includes(TAX_CODE)}
                  disabled={isView}
                />
                <FormInput
                  name={STATE_TAX_ID}
                  control={form.control}
                  label="Tax State ID"
                  placeholder="Please enter"
                  error={errors[STATE_TAX_ID]?.message}
                  isRequired={requiredFields.includes(STATE_TAX_ID)}
                  disabled={isView}
                />
                <FormInput
                  name={TAX_ID}
                  control={form.control}
                  label="Tax ID"
                  placeholder="Please enter"
                  error={errors[TAX_ID]?.message}
                  isRequired={requiredFields.includes(TAX_ID)}
                  disabled={isView}
                />
              </div>
            </div>
            <div className="flex flex-row justify-end gap-3  py-3">
              <Button
                variant="outline"
                type="button"
                onClick={onCancel}
                disabled={isAddPending || isUpdatePending}
              >
                Cancel
              </Button>
              {!isView && (
                <Button
                  type="submit"
                  disabled={isAddPending || isUpdatePending}
                >
                  {isAddPending ||
                    (isUpdatePending && <Loader variant="secondary" />)}{" "}
                  Save
                </Button>
              )}
            </div>
          </form>
        </FormProvider>
      )}
    </>
  );
};

export default Step2;
